// ============================================================================
// CHECK-OUT ENDPOINTS
// ============================================================================

import { buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/CheckOut';

/*
 * Read-only. The preview + POST endpoints were removed when departure was
 * separated from settlement — see departure.endpoints.ts.
 */
export const checkOutEndpoints = {
  /** GET /api/v1/CheckOut/by-booking/{bookingId} */
  getByBooking: (bookingId: ID) =>
    buildEndpointWithParams(`${BASE_PATH}/by-booking/:bookingId`, { bookingId }),
} as const;

export default checkOutEndpoints;
